import React, { useState, useEffect } from "react";
import Button from "shared/Button";
import { getRatingsMessage } from "helpers/getRatingsMessage";
import { useDispatch, useSelector } from "react-redux";
import {
  hideVideoModal,
  showVideoModal,
  togglePamentModal,
  modalPayment,
  modalPaidInCollection,
  modalVideo,
} from "store/modalReducer";
import { paymentBuying } from "store/paymentReducer";
import { colors } from "styles/colors";
import {
  PreviewWrap,
  PreviewImg,
  PreviewContent,
  PreviewDesc,
  Tag,
  NoImage,
  TagsWrap,
  PreviewInfo,
  PreviewBarWrap,
  PreviewButtons,
  SpinnerWrap,
} from "styles/Preview.styled";
import { Wraper } from "components/RecipePage/styled";
import AddGrocery from "./AddGrocery";
import BtnToolBar from "shared/BtnToolBar/index";
import Modal from "shared/Modal";
import Rating from "shared/Rating";
import { unSaveRecipeOrCollection, saveRecipeOrCollection, buyCollection } from "store/recipesReducer/recipesActions";
import { saveCollectionPage } from "store/collectionReducer";
import { toggleModal, isUserLogin } from "store/loginReducer";
import { purshaseCollection } from "api/api";
import { MainWrapper, RatingWrapMobile, RatingText } from "../styled";
import { ModalContainer } from "components/CollectionInstraction/styled";

import Collapse from "shared/Collapse";
import checkCollectionDirections from "helpers/checkCollectionDirections";
import cloudfront from "helpers/cloudfront";
import { saveAs } from "file-saver";
import { setCollection } from "store/collectionReducer/collectionActions";

import dynamic from "next/dynamic";
const Payment = dynamic(() => import("components/Payment"), { ssr: false });
const CollectionInstraction = dynamic(() => import("components/CollectionInstraction"));
import PaidInCollection from "components/PaidInCollection";
import { getImageName } from "../../../helpers";
import { useRenderDevice } from "helpers/hooks/useRenderDevice";

import { Spinner } from "styles/App.styled";
import { getMainVideo } from "../../../helpers/video";

const btns = [
  { name: "Share", icon: "share2" },
  { name: "Like", icon: "saveslide" },
];

const PreviewDisplay = ({
  image,
  description,
  tags,
  isPaid,
  id,
  price,
  purchased,
  collection,
  paidInCollectionsData,
  isOwner,
  isFullAccess,
}) => {
  const isMobile = useRenderDevice({ max: 768 });
  const isPaymentModal = useSelector(modalPayment);
  const isPaidInCollectionModal = useSelector(modalPaidInCollection);
  const isShowModal = useSelector(modalVideo);
  const dispatch = useDispatch();
  const isLogin = useSelector(isUserLogin);
  const loading = useSelector(paymentBuying);

  const showPayment = () => {
    dispatch(hideVideoModal());
    dispatch(togglePamentModal(true));
  };

  const savePdf = () => {
    try {
      saveAs(collection.collection_pdf_file_url, collection.collection_pdf_file_name);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClick = () => {
    if (!isLogin) dispatch(toggleModal(true));
    else if (collection.saved) {
      dispatch(
        unSaveRecipeOrCollection({
          type: "collections",
          id: collection.id,
          setSaved: saveCollectionPage,
        })
      );
    } else {
      dispatch(
        saveRecipeOrCollection({
          type: "collections",
          id: collection.id,
          setSaved: saveCollectionPage,
        })
      );
    }
  };

  const renderBtn = () => {
    if (isOwner) return null;
    if (purchased) {
      return <Button stylType="primary" text="Purchased" disabled />;
    }
    if (isPaid) {
      return (
        <Button
          stylType="primary"
          text={`Buy Collection $${price}`}
          id="buy"
          color={colors.RED}
          loading={loading}
          disabled={loading}
          onClick={showPayment}
        />
      );
    } else return <Button stylType="primary" text="Free" disabled />;
  };

  const showInfo = checkCollectionDirections(collection.recipe);

  const [imageLoading, setImageLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      if (imageLoading) {
        setImageLoading(false);
      }
    }, 1000);
  }, [image]);

  return (
    <>
      <MainWrapper>
        <PreviewWrap>
          <PreviewImg>
            {image && imageLoading && (
              <SpinnerWrap>
                <Spinner />
              </SpinnerWrap>
            )}
            {image ? (
              <img
                onLoad={() => {
                  setImageLoading(false);
                }}
                src={cloudfront({ href: image, size: "large" })}
                alt={getImageName(image)}
              />
            ) : (
              <NoImage />
            )}
          </PreviewImg>
          <PreviewContent>
            <PreviewInfo>
              <PreviewBarWrap>
                {isMobile && (
                  <>
                    <RatingWrapMobile hasReviews={collection.review_count}>
                      <RatingText>{getRatingsMessage(collection.review_count)}</RatingText>
                      <Rating value={collection.rating} />
                    </RatingWrapMobile>
                    <BtnToolBar
                      saved={collection.saved}
                      onSave={handleClick}
                      btns={btns}
                      socialImgUrl={image}
                      mealPlanId={collection.id}
                    />
                  </>
                )}
              </PreviewBarWrap>
              <TagsWrap>
                <Collapse>
                  {tags.map((tag) => {
                    return <Tag key={tag.id}>{tag.name}</Tag>;
                  })}
                </Collapse>
              </TagsWrap>
              <PreviewDesc>
                {description?.split("\n").map((val, i) => (
                  <p key={i}>{val}</p>
                ))}
              </PreviewDesc>
            </PreviewInfo>
            <PreviewButtons>
              {showInfo.steps && (
                <Wraper className="infoBtn">
                  <Button
                    stylType="secondary"
                    disabled="disabled"
                    text="Includes step-by-step instructions"
                    iconLeft="list_play"
                    btnSize="larger"
                  />
                </Wraper>
              )}
              {showInfo.videos && (
                <Wraper className="infoBtn">
                  <Button
                    stylType="secondary"
                    disabled="disabled"
                    text="Includes Videos"
                    iconLeft="video-player-movie"
                    btnSize="larger"
                  />
                </Wraper>
              )}

              <Wraper className="buyBlock">
                {renderBtn()}
                {!!getMainVideo(collection) && (
                  <Button
                    onClick={() => dispatch(showVideoModal())}
                    color={colors.WHITE}
                    textColor={colors.RED}
                    stylType="outline"
                    text="Watch Video"
                    iconRight="play_icon"
                    btnSize="larger"
                  />
                )}

                {!!collection.collection_pdf_file_name && (
                  <Button
                    className="download"
                    onClick={savePdf}
                    textColor={colors.RED}
                    stylType="outline"
                    text={collection.collection_pdf_file_name}
                    iconRight="download"
                    iconLeft="pdf_icon"
                    btnSize="larger"
                    disabled={isFullAccess ? false : true}
                    tooltip={isFullAccess ? false : "Buy to download the file"}
                  />
                )}

                <AddGrocery collection={collection} />
              </Wraper>
            </PreviewButtons>
          </PreviewContent>
        </PreviewWrap>

        {isPaymentModal && (
          <Modal>
            <Payment
              modalLabel="Buy Collection"
              price={price}
              purshaseConfirm={buyCollection}
              purshase={(id) => purshaseCollection({ collection: id })}
              purshaseItem={id}
              hasStripe={collection.has_stripe_account}
              creator={collection.collection_creator}
              refetchProduct={setCollection}
            />
          </Modal>
        )}

        {isPaidInCollectionModal && <PaidInCollection paidInCollectionsData={paidInCollectionsData} />}
      </MainWrapper>
      <ModalContainer>
        {isShowModal && (
          <Modal type="primary">
            <CollectionInstraction collection={collection} price={price} buyItem={showPayment} />
          </Modal>
        )}
      </ModalContainer>
    </>
  );
};

export default React.memo(PreviewDisplay);
